module.exports = {
    path: '/leaderboard',
    component: () => import('@lb/Leaderboard'),
    meta: { module: 'lb' },
    children: [
        {
            path: '',
            component: () => import('@lb/components/Home')
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/leaderboard/router.js